import React from 'react'
import {IconProps} from '../../types/IconProps'

const ForceChangeIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13 16.4373C13 17.5673 13 18.1323 13.2283 18.4093C13.4266 18.65 13.7258 18.7843 14.0374 18.7727C14.3961 18.7592 14.8184 18.3839 15.663 17.6331L20.6547 13.1961C21.12 12.7825 21.3526 12.5757 21.4383 12.3315C21.5136 12.1171 21.5136 11.8834 21.4383 11.6689C21.3526 11.4247 21.12 11.2179 20.6547 10.8044L15.663 6.3673C14.8184 5.61655 14.3961 5.24118 14.0374 5.22775C13.7258 5.21609 13.4266 5.35046 13.2283 5.59111C13 5.86811 13 6.43313 13 7.56316V16.4373Z'
        stroke={color || 'black'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 16.4373C2 17.5673 2 18.1323 2.22827 18.4093C2.42657 18.65 2.72579 18.7843 3.0374 18.7727C3.39609 18.7592 3.81839 18.3839 4.66298 17.6331L9.65466 13.1961C10.12 12.7825 10.3526 12.5757 10.4383 12.3315C10.5136 12.1171 10.5136 11.8834 10.4383 11.6689C10.3526 11.4247 10.12 11.2179 9.65466 10.8044L4.66298 6.3673C3.81839 5.61655 3.39609 5.24118 3.0374 5.22775C2.72579 5.21609 2.42657 5.35046 2.22827 5.59111C2 5.86811 2 6.43313 2 7.56316V16.4373Z'
        stroke={color || 'black'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default ForceChangeIcon
